import { Box, Title } from '@mantine/core';
export default function EventTotals({label, amount}) {
  return (
    <Box>
      <Title color="orange" order={2} mb={10}>Total {label}</Title>  
      <Title mb={10} order={3}>${amount || 0}</Title>
    </Box>
  )
}